import Styled from 'styled-components';
import Arrows from '@catalogo/ui-americanas-desktop-svg/sort.svg';

const DropDownStyle = Styled.div`
  display: flex;
  justify-content: initial;
  align-items: center;
  transition: all .3s ease 0s;
  min-width: 130px;
`;

const DropDownContainer = Styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 130px;
  
  > button {
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 5px;
    outline: 0;
    cursor: pointer;
    background: none;
    font-weight: normal;
    color: #666;
    font-size: 14px;
    border: none;
    text-transform: ${({ theme }) => theme.btnTextTransform};
    min-width: 100px;

    &:hover {
      color: #000;
    }
    
    &:disabled {
      opacity: .6;
    }
  }
`;

const SortIcon = Styled(Arrows)`
  fill: ${({ theme }) => theme.primaryColor};
  width: 13px;
  height: 13px;
`;

const SortTitle = Styled.span`
  display: flex;
  color: ${({ theme }) => theme.primaryColor};
  text-transform: ${({ theme }) => theme.titleTransform};
  font-size: ${({ theme }) => theme.fontSize.xs};
  margin: 0 6px 0 5px;
`;

const ListDropDown = Styled.div`
  background-color: #FFF;
  backdrop-filter: blur(10px);
  border: 1px solid #f8f8f8;
  position: absolute;
  border-radius: 5px;
  left: 50px;
  top: 26px;
  height: auto;
  opacity: 0;
  visibility: hidden;
  height: auto;
  min-width: 105px;
  transition: all .3s ease-in-out;
  overflow: ${({ theme }) => theme.overflow};
  overflow-y: inherit;
  z-index: 100;
  
  &.show-dropdown{
    opacity: 1;
    visibility: visible;
    cursor: pointer;
  }
`;

const Label = Styled.div`
  text-transform: lowercase;
`;

export default DropDownStyle;
export { DropDownStyle, DropDownContainer, ListDropDown, Label, SortIcon, SortTitle };
